export const ATTACHMENT_TYPES = {
  vendor_correspondence: {
    label: "Vendor Correspondence"
  },
  traceability: {
    label: "Traceability"
  },
  tag_copies: {
    label: "Tag Copies"
  },
  packing_slip: {
    label: "Packing Slip"
  },
  photos: {
    label: "Photos"
  },
  signed_exchange_agreement: {
    label: "Signed Exchange Agreement"
  },
  external_link: {
    label: "External Link"
  },
  end_user_agreement: {
    label: "End User Agreement"
  }
};

export const MANAGED_REPAIR_ORDER = "managed_repair_order";



// WEBPACK FOOTER //
// ./app/modules/ManagedRepairOrders/constants.js